import { Maximize2, Minimize2, X } from 'lucide-react';

import { Button } from '@/components/Button/Button';

import { ChatOverflowMenu } from './ChatOverflowMenu';
import type { ChatPanelSize } from './useChatPanelSize';
import styles from './ChatPanel.module.css';

interface ChatHeaderProps {
  canReset?: boolean;
  // False on narrow viewports, where the panel is already full screen.
  canResize?: boolean;
  onClose: () => void;
  onReset?: () => void;
  onToggleSize?: () => void;
  size?: ChatPanelSize;
}

export function ChatHeader({
  canReset = false,
  canResize = false,
  onClose,
  onReset,
  onToggleSize,
  size = 'default',
}: ChatHeaderProps) {
  const isWide = size === 'wide';

  return (
    <div className={styles.header}>
      {canReset && onReset ? (
        <ChatOverflowMenu onClearConversation={onReset} />
      ) : null}

      {canResize && onToggleSize ? (
        <Button
          // The label names the ACTION, and aria-pressed carries the state, so
          // the size change is conveyed without relying on the animation.
          aria-label={isWide ? 'Exit wide mode' : 'Expand to wide mode'}
          aria-pressed={isWide}
          className={styles.headerButton}
          iconOnly
          onClick={onToggleSize}
          variant="ghost"
        >
          {isWide ? (
            <Minimize2 aria-hidden="true" size={18} />
          ) : (
            <Maximize2 aria-hidden="true" size={18} />
          )}
        </Button>
      ) : null}

      <Button
        aria-label="Close chat"
        className={styles.closeButton}
        iconOnly
        onClick={onClose}
        variant="ghost"
      >
        <X aria-hidden="true" size={18} />
      </Button>
    </div>
  );
}
